<template>
    <div class="toast-container">
        <span class="toast-container__message">{{ message }}</span>
        <MyActionBtn 
            :btnText="buttonName" 
            :size="isUnderOrEqualViewport1024 ? 'small' : 'medium'" 
            @click="triggerActionBtn" 
        />
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import viewport from '~/mixins/viewport';

export default {
    mixins: [viewport],
    name: 'ActionComponent',
    props: {
        message: VueTypes.string.def('Default message'),
        buttonName: VueTypes.string.def('')
    },
    components: {
        MyActionBtn: () => import('@/themes/novaporta/components/ui/MyActionBtn')
    },
    methods: {
        triggerActionBtn() {
            this.$emit('action');
            this.$emit('close-toast');
        }
    }
};
</script>

<style scoped lang="scss">
@import './styles.scss';
</style>
